// This file was automatically generated and should not be edited.

// ====================================================
// Domain Graph Type Identity and ID Prefix Mapping
// ====================================================

import {objectFromEntries} from '@benchling/js-utils';

import {CoreObjectIdPrefix, ObjectType} from 'app-core/framework/CoreObjectConstants';

/** @package */
export const GeneratedDomainGraphType = {
  AA_MONOMER: 'AA_MONOMER',
  AA_PART_LINK_FIELD_DEFINITION: 'AA_PART_LINK_FIELD_DEFINITION',
  AA_SEQUENCE: 'AA_SEQUENCE',
  AA_SEQUENCE_LINK_FIELD_DEFINITION: 'AA_SEQUENCE_LINK_FIELD_DEFINITION',
  AA_SEQUENCE_SCHEMA: 'AA_SEQUENCE_SCHEMA',
  AGENT_SKILL: 'AGENT_SKILL',
  AGENT_SKILL_FILE: 'AGENT_SKILL_FILE',
  AI_MODEL: 'AI_MODEL',
  ALIGNED_NUCLEOTIDE_SEQUENCE: 'ALIGNED_NUCLEOTIDE_SEQUENCE',
  ANALYSIS: 'ANALYSIS',
  ANALYSIS_TEMPLATE: 'ANALYSIS_TEMPLATE',
  ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE: 'ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE',
  ANALYSIS_TEMPLATE_VARIABLE: 'ANALYSIS_TEMPLATE_VARIABLE',
  ANTIBODY_LINK_FIELD_DEFINITION: 'ANTIBODY_LINK_FIELD_DEFINITION',
  ANY_ENTITY_LINK_FIELD_DEFINITION: 'ANY_ENTITY_LINK_FIELD_DEFINITION',
  APP_CANVAS: 'APP_CANVAS',
  APP_DEFINITION: 'APP_DEFINITION',
  APP_DEFINITION_VERSION: 'APP_DEFINITION_VERSION',
  APP_INSTALLATION: 'APP_INSTALLATION',
  APP_SESSION: 'APP_SESSION',
  ASSAY_REQUEST_LINK_FIELD_DEFINITION: 'ASSAY_REQUEST_LINK_FIELD_DEFINITION',
  ASSAY_RESULT_LINK_FIELD_DEFINITION: 'ASSAY_RESULT_LINK_FIELD_DEFINITION',
  ASSAY_RUN_LINK_FIELD_DEFINITION: 'ASSAY_RUN_LINK_FIELD_DEFINITION',
  ASSEMBLY: 'ASSEMBLY',
  ASYNC_TASK: 'ASYNC_TASK',
  AUDIT_LOG: 'AUDIT_LOG',
  AV_SCAN_RECORD: 'AV_SCAN_RECORD',
  BASE_FIELD_DEFINITION: 'BASE_FIELD_DEFINITION',
  BASE_MOLECULE_LINK_FIELD_DEFINITION: 'BASE_MOLECULE_LINK_FIELD_DEFINITION',
  BENCHLING_OBJECT_SCHEMA_V2: 'BENCHLING_OBJECT_SCHEMA_V2',
  BLOB_LINK_FIELD_DEFINITION: 'BLOB_LINK_FIELD_DEFINITION',
  BLOCK_VISUALIZATION: 'BLOCK_VISUALIZATION',
  BOOLEAN_FIELD_DEFINITION: 'BOOLEAN_FIELD_DEFINITION',
  BOX: 'BOX',
  BOX_SCHEMA: 'BOX_SCHEMA',
  BUSINESS_RULE: 'BUSINESS_RULE',
  CANVAS_DEFINITION: 'CANVAS_DEFINITION',
  CANVAS_VERSION: 'CANVAS_VERSION',
  CHART: 'CHART',
  CHAT_SESSION: 'CHAT_SESSION',
  COLLABORATION: 'COLLABORATION',
  CONFIG_IMPORT_HISTORY_ENTRY: 'CONFIG_IMPORT_HISTORY_ENTRY',
  CONTAINER: 'CONTAINER',
  CONTAINER_SCHEMA: 'CONTAINER_SCHEMA',
  CUSTOM_ENTITY: 'CUSTOM_ENTITY',
  CUSTOM_ENTITY_LINK_FIELD_DEFINITION: 'CUSTOM_ENTITY_LINK_FIELD_DEFINITION',
  CUSTOM_ENTITY_SCHEMA: 'CUSTOM_ENTITY_SCHEMA',
  DATASET: 'DATASET',
  DATA_FRAME: 'DATA_FRAME',
  DATE_FIELD_DEFINITION: 'DATE_FIELD_DEFINITION',
  DATE_TIME_FIELD_DEFINITION: 'DATE_TIME_FIELD_DEFINITION',
  DNA_OLIGO: 'DNA_OLIGO',
  DNA_OLIGO_LINK_FIELD_DEFINITION: 'DNA_OLIGO_LINK_FIELD_DEFINITION',
  DNA_OLIGO_SCHEMA: 'DNA_OLIGO_SCHEMA',
  DNA_PART_LINK_FIELD_DEFINITION: 'DNA_PART_LINK_FIELD_DEFINITION',
  DNA_SEQUENCE: 'DNA_SEQUENCE',
  DNA_SEQUENCE_LINK_FIELD_DEFINITION: 'DNA_SEQUENCE_LINK_FIELD_DEFINITION',
  DNA_SEQUENCE_SCHEMA: 'DNA_SEQUENCE_SCHEMA',
  DOCUMENT: 'DOCUMENT',
  DOCUMENT_PART: 'DOCUMENT_PART',
  DROPDOWN: 'DROPDOWN',
  DROPDOWN_LINK_FIELD_DEFINITION: 'DROPDOWN_LINK_FIELD_DEFINITION',
  DROPDOWN_OPTION: 'DROPDOWN_OPTION',
  ENTITY_SCHEMA: 'ENTITY_SCHEMA',
  ENTRY: 'ENTRY',
  ENTRY_LINK_FIELD_DEFINITION: 'ENTRY_LINK_FIELD_DEFINITION',
  ENTRY_SCHEMA: 'ENTRY_SCHEMA',
  ENTRY_SUBTEMPLATE: 'ENTRY_SUBTEMPLATE',
  ENTRY_TEMPLATE: 'ENTRY_TEMPLATE',
  ENZYME: 'ENZYME',
  ENZYME_LIST: 'ENZYME_LIST',
  EQUIPMENT_LINK_FIELD_DEFINITION: 'EQUIPMENT_LINK_FIELD_DEFINITION',
  EQUIPMENT_SCHEMA: 'EQUIPMENT_SCHEMA',
  EVENT_SUBSCRIPTION: 'EVENT_SUBSCRIPTION',
  EXAMPLE_TYPE: 'EXAMPLE_TYPE',
  FEATURE_LIBRARY: 'FEATURE_LIBRARY',
  FEATURE_LIBRARY_ITEM: 'FEATURE_LIBRARY_ITEM',
  FIELDSET: 'FIELDSET',
  FIELDSET_LINK_FIELD_DEFINITION: 'FIELDSET_LINK_FIELD_DEFINITION',
  FILE: 'FILE',
  FLOAT_FIELD_DEFINITION: 'FLOAT_FIELD_DEFINITION',
  FOLDER: 'FOLDER',
  FORM_DEFINITION: 'FORM_DEFINITION',
  GERMLINE: 'GERMLINE',
  INTEGER_FIELD_DEFINITION: 'INTEGER_FIELD_DEFINITION',
  INTERNAL_PIPELINE: 'INTERNAL_PIPELINE',
  JELLYFISH: 'JELLYFISH',
  JELLYFISH_SCHEMA: 'JELLYFISH_SCHEMA',
  JSON_FIELD_DEFINITION: 'JSON_FIELD_DEFINITION',
  LABEL_TEMPLATE: 'LABEL_TEMPLATE',
  LADDER: 'LADDER',
  LEGACY_APP_INSTALLATION: 'LEGACY_APP_INSTALLATION',
  LEGACY_DATA_IMPORT_RUN: 'LEGACY_DATA_IMPORT_RUN',
  LIBRARY_PARAMETER_DEFINITION: 'LIBRARY_PARAMETER_DEFINITION',
  LOCATION: 'LOCATION',
  LOCATION_SCHEMA: 'LOCATION_SCHEMA',
  LONG_TEXT_FIELD_DEFINITION: 'LONG_TEXT_FIELD_DEFINITION',
  MATRIX_PLATE: 'MATRIX_PLATE',
  MATRIX_PLATE_SCHEMA: 'MATRIX_PLATE_SCHEMA',
  MCP_SERVER_CONFIG: 'MCP_SERVER_CONFIG',
  MCP_SERVER_DEFINITION: 'MCP_SERVER_DEFINITION',
  MCP_SERVER_USER_CONFIG: 'MCP_SERVER_USER_CONFIG',
  MIXTURE: 'MIXTURE',
  MIXTURE_LINK_FIELD_DEFINITION: 'MIXTURE_LINK_FIELD_DEFINITION',
  MIXTURE_SCHEMA: 'MIXTURE_SCHEMA',
  MODIFIED_NUCLEOTIDE: 'MODIFIED_NUCLEOTIDE',
  MOLECULE: 'MOLECULE',
  MOLECULE_LINK_FIELD_DEFINITION: 'MOLECULE_LINK_FIELD_DEFINITION',
  MOLECULE_SCHEMA: 'MOLECULE_SCHEMA',
  NUCLEOTIDE_ALIGNMENT: 'NUCLEOTIDE_ALIGNMENT',
  OLIGO_CONJUGATE: 'OLIGO_CONJUGATE',
  OLIGO_CONJUGATE_LINK_FIELD_DEFINITION: 'OLIGO_CONJUGATE_LINK_FIELD_DEFINITION',
  OLIGO_CONJUGATE_SCHEMA: 'OLIGO_CONJUGATE_SCHEMA',
  OLIGO_DUPLEX: 'OLIGO_DUPLEX',
  OLIGO_DUPLEX_LINK_FIELD_DEFINITION: 'OLIGO_DUPLEX_LINK_FIELD_DEFINITION',
  OLIGO_DUPLEX_SCHEMA: 'OLIGO_DUPLEX_SCHEMA',
  ORGANIZATION: 'ORGANIZATION',
  PIPELINE_STEP: 'PIPELINE_STEP',
  PLATE: 'PLATE',
  PLATE_DESIGN_TEMPLATE: 'PLATE_DESIGN_TEMPLATE',
  PLATE_SCHEMA: 'PLATE_SCHEMA',
  POLICY: 'POLICY',
  PREDICTION_BATCH: 'PREDICTION_BATCH',
  PREDICTION_JOB: 'PREDICTION_JOB',
  PRINTER: 'PRINTER',
  PROCEDURE: 'PROCEDURE',
  PROCEDURE_FLOWCHART: 'PROCEDURE_FLOWCHART',
  PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY: 'PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY',
  PROCEDURE_FLOWCHART_VERSION: 'PROCEDURE_FLOWCHART_VERSION',
  PROCEDURE_METHOD_DEFINITION_VERSION: 'PROCEDURE_METHOD_DEFINITION_VERSION',
  PROCEDURE_METHOD_EXECUTION_INSTANCE: 'PROCEDURE_METHOD_EXECUTION_INSTANCE',
  PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION: 'PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION',
  PROCEDURE_PARAMETER: 'PROCEDURE_PARAMETER',
  PROCEDURE_PARAMETER_CONFIRMATION_VALUE: 'PROCEDURE_PARAMETER_CONFIRMATION_VALUE',
  PROCEDURE_PARAMETER_MEASURED_VALUE: 'PROCEDURE_PARAMETER_MEASURED_VALUE',
  PROCEDURE_PARAMETER_PLANNED_VALUE: 'PROCEDURE_PARAMETER_PLANNED_VALUE',
  PROCEDURE_PARAMETER_VERSION: 'PROCEDURE_PARAMETER_VERSION',
  PROCEDURE_RUN: 'PROCEDURE_RUN',
  PROCEDURE_RUN_CONDITION: 'PROCEDURE_RUN_CONDITION',
  PROCEDURE_RUN_CONDITION_REPLICATE: 'PROCEDURE_RUN_CONDITION_REPLICATE',
  PROCEDURE_RUN_PLAN: 'PROCEDURE_RUN_PLAN',
  PROCEDURE_RUN_PLAN_CONDITION: 'PROCEDURE_RUN_PLAN_CONDITION',
  PROCEDURE_RUN_REPLICATE_EDGE: 'PROCEDURE_RUN_REPLICATE_EDGE',
  PROCEDURE_STEP_DEFINITION_VERSION: 'PROCEDURE_STEP_DEFINITION_VERSION',
  PROCEDURE_STEP_EXECUTION_INSTANCE: 'PROCEDURE_STEP_EXECUTION_INSTANCE',
  PROJECT: 'PROJECT',
  PROTEIN: 'PROTEIN',
  PROTEIN_FORMAT: 'PROTEIN_FORMAT',
  PROTEIN_SCHEMA: 'PROTEIN_SCHEMA',
  PUBLISHING_RECORD: 'PUBLISHING_RECORD',
  REACTION: 'REACTION',
  REGISTRY: 'REGISTRY',
  REQUEST_SCHEMA: 'REQUEST_SCHEMA',
  REQUEST_TASK_SCHEMA: 'REQUEST_TASK_SCHEMA',
  REQUEST_V2_DEFINITION: 'REQUEST_V2_DEFINITION',
  REQUEST_V2_SUBMISSION: 'REQUEST_V2_SUBMISSION',
  RESULT: 'RESULT',
  RESULT_SCHEMA: 'RESULT_SCHEMA',
  RNA_OLIGO: 'RNA_OLIGO',
  RNA_OLIGO_LINK_FIELD_DEFINITION: 'RNA_OLIGO_LINK_FIELD_DEFINITION',
  RNA_OLIGO_SCHEMA: 'RNA_OLIGO_SCHEMA',
  RNA_SEQUENCE: 'RNA_SEQUENCE',
  RNA_SEQUENCE_LINK_FIELD_DEFINITION: 'RNA_SEQUENCE_LINK_FIELD_DEFINITION',
  RNA_SEQUENCE_SCHEMA: 'RNA_SEQUENCE_SCHEMA',
  ROUTINE: 'ROUTINE',
  ROUTINE_EXECUTION: 'ROUTINE_EXECUTION',
  RUN: 'RUN',
  RUN_SCHEMA: 'RUN_SCHEMA',
  SALT: 'SALT',
  SAMPLE_DEFINITION: 'SAMPLE_DEFINITION',
  SAMPLE_TYPE: 'SAMPLE_TYPE',
  SCHEMA_LINK_FIELD_DEFINITION: 'SCHEMA_LINK_FIELD_DEFINITION',
  SCRATCH_FILE: 'SCRATCH_FILE',
  SCRATCH_PLATE: 'SCRATCH_PLATE',
  SERVICE_PRINCIPAL: 'SERVICE_PRINCIPAL',
  SOLVENT: 'SOLVENT',
  SQL_DASHBOARD: 'SQL_DASHBOARD',
  SQL_DASHBOARD_BLOCK: 'SQL_DASHBOARD_BLOCK',
  SQL_DASHBOARD_LINK: 'SQL_DASHBOARD_LINK',
  STAGE_ENTRY: 'STAGE_ENTRY',
  STAR: 'STAR',
  STATIC_SCHEMA_INTERFACE: 'STATIC_SCHEMA_INTERFACE',
  STATIC_VALIDATION_RULE_TEMPLATE: 'STATIC_VALIDATION_RULE_TEMPLATE',
  STORABLE_LINK_FIELD_DEFINITION: 'STORABLE_LINK_FIELD_DEFINITION',
  STUDY: 'STUDY',
  STUDY_ITEM_ASSOCIATION: 'STUDY_ITEM_ASSOCIATION',
  STUDY_SAMPLE_TEST_PLAN: 'STUDY_SAMPLE_TEST_PLAN',
  STUDY_SCHEMA: 'STUDY_SCHEMA',
  SYSTEM_CATEGORY_LINK_FIELD_DEFINITION: 'SYSTEM_CATEGORY_LINK_FIELD_DEFINITION',
  TEAM: 'TEAM',
  TEMPLATE_COLLECTION: 'TEMPLATE_COLLECTION',
  TENANT_CONFIG: 'TENANT_CONFIG',
  TENTACLE: 'TENTACLE',
  TEST_DEFINITION: 'TEST_DEFINITION',
  TEST_ORDER: 'TEST_ORDER',
  TEXT_FIELD_DEFINITION: 'TEXT_FIELD_DEFINITION',
  TRANSCRIPTION_LINK_FIELD_DEFINITION: 'TRANSCRIPTION_LINK_FIELD_DEFINITION',
  TRANSLATION_LINK_FIELD_DEFINITION: 'TRANSLATION_LINK_FIELD_DEFINITION',
  TREATMENT_GROUP: 'TREATMENT_GROUP',
  TRIAL_SAMPLE_TESTING_STUDY_DESIGN: 'TRIAL_SAMPLE_TESTING_STUDY_DESIGN',
  UNIT: 'UNIT',
  UNIT_TYPE: 'UNIT_TYPE',
  USER: 'USER',
  VALIDATION_RULE: 'VALIDATION_RULE',
  WAREHOUSE_CREDENTIAL: 'WAREHOUSE_CREDENTIAL',
  WAREHOUSE_CUSTOM_VIEW: 'WAREHOUSE_CUSTOM_VIEW',
  WELL_PLATE: 'WELL_PLATE',
  WELL_PLATE_SCHEMA: 'WELL_PLATE_SCHEMA',
  WORKFLOW_END_NODE_DETAILS: 'WORKFLOW_END_NODE_DETAILS',
  WORKFLOW_FLOWCHART_CONFIG: 'WORKFLOW_FLOWCHART_CONFIG',
  WORKFLOW_FLOWCHART_CONFIG_VERSION: 'WORKFLOW_FLOWCHART_CONFIG_VERSION',
  WORKFLOW_FLOWCHART_EDGE_CONFIG: 'WORKFLOW_FLOWCHART_EDGE_CONFIG',
  WORKFLOW_FLOWCHART_NODE_CONFIG: 'WORKFLOW_FLOWCHART_NODE_CONFIG',
  WORKFLOW_OUTPUT: 'WORKFLOW_OUTPUT',
  WORKFLOW_OUTPUT_NODE_DETAILS: 'WORKFLOW_OUTPUT_NODE_DETAILS',
  WORKFLOW_OUTPUT_SCHEMA: 'WORKFLOW_OUTPUT_SCHEMA',
  WORKFLOW_ROOT_NODE_DETAILS: 'WORKFLOW_ROOT_NODE_DETAILS',
  WORKFLOW_ROUTER_FUNCTION: 'WORKFLOW_ROUTER_FUNCTION',
  WORKFLOW_ROUTER_NODE_DETAILS: 'WORKFLOW_ROUTER_NODE_DETAILS',
  WORKFLOW_TASK: 'WORKFLOW_TASK',
  WORKFLOW_TASK_DEFINITION: 'WORKFLOW_TASK_DEFINITION',
  WORKFLOW_TASK_DEFINITION_VERSION: 'WORKFLOW_TASK_DEFINITION_VERSION',
  WORKFLOW_TASK_GROUP: 'WORKFLOW_TASK_GROUP',
  WORKFLOW_TASK_NODE_DETAILS: 'WORKFLOW_TASK_NODE_DETAILS',
  WORKFLOW_TASK_SCHEMA: 'WORKFLOW_TASK_SCHEMA',
  WORKLIST: 'WORKLIST',
  WORKSHEET: 'WORKSHEET',
} as const;

/** @package */
export const ID_PREFIX_TO_DOMAIN_GRAPH_TYPES_ENTRIES = [
  ['aamon', new Set([GeneratedDomainGraphType.AA_MONOMER])],
  ['abfmt', new Set([GeneratedDomainGraphType.PROTEIN_FORMAT])],
  ['agtskl', new Set([GeneratedDomainGraphType.AGENT_SKILL])],
  ['agtsklfl', new Set([GeneratedDomainGraphType.AGENT_SKILL_FILE])],
  ['aimdl', new Set([GeneratedDomainGraphType.AI_MODEL])],
  ['alnseq', new Set([GeneratedDomainGraphType.ALIGNED_NUCLEOTIDE_SEQUENCE])],
  ['ana', new Set([GeneratedDomainGraphType.ANALYSIS])],
  ['anastep', new Set([GeneratedDomainGraphType.PIPELINE_STEP])],
  ['anatmpl', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE])],
  ['anatmpldfv', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE_DATA_FRAME_VARIABLE])],
  ['anatmplvar', new Set([GeneratedDomainGraphType.ANALYSIS_TEMPLATE_VARIABLE])],
  [
    'app',
    new Set([GeneratedDomainGraphType.APP_INSTALLATION, GeneratedDomainGraphType.LEGACY_APP_INSTALLATION]),
  ],
  ['appdef', new Set([GeneratedDomainGraphType.APP_DEFINITION])],
  ['appdefv', new Set([GeneratedDomainGraphType.APP_DEFINITION_VERSION])],
  [
    'assaysch',
    new Set([
      GeneratedDomainGraphType.REQUEST_SCHEMA,
      GeneratedDomainGraphType.RESULT_SCHEMA,
      GeneratedDomainGraphType.RUN_SCHEMA,
    ]),
  ],
  ['assem', new Set([GeneratedDomainGraphType.ASSEMBLY])],
  ['atsk', new Set([GeneratedDomainGraphType.ASYNC_TASK])],
  ['auditeff', new Set([GeneratedDomainGraphType.AUDIT_LOG])],
  ['avs', new Set([GeneratedDomainGraphType.AV_SCAN_RECORD])],
  ['axdash', new Set([GeneratedDomainGraphType.SQL_DASHBOARD])],
  ['axdlink', new Set([GeneratedDomainGraphType.SQL_DASHBOARD_LINK])],
  ['axquery', new Set([GeneratedDomainGraphType.SQL_DASHBOARD_BLOCK])],
  ['axvis', new Set([GeneratedDomainGraphType.BLOCK_VISUALIZATION])],
  [
    'bfi',
    new Set([
      GeneratedDomainGraphType.CUSTOM_ENTITY,
      GeneratedDomainGraphType.OLIGO_CONJUGATE,
      GeneratedDomainGraphType.OLIGO_DUPLEX,
      GeneratedDomainGraphType.PROTEIN,
    ]),
  ],
  ['box', new Set([GeneratedDomainGraphType.BOX])],
  ['boxsch', new Set([GeneratedDomainGraphType.BOX_SCHEMA])],
  ['bsrl', new Set([GeneratedDomainGraphType.BUSINESS_RULE])],
  ['builtinabfmt', new Set([GeneratedDomainGraphType.PROTEIN_FORMAT])],
  ['chart', new Set([GeneratedDomainGraphType.CHART])],
  ['chtsess', new Set([GeneratedDomainGraphType.CHAT_SESSION])],
  ['clb', new Set([GeneratedDomainGraphType.COLLABORATION])],
  ['cnvs', new Set([GeneratedDomainGraphType.APP_CANVAS])],
  ['cnvsdef', new Set([GeneratedDomainGraphType.CANVAS_DEFINITION])],
  ['cnvsver', new Set([GeneratedDomainGraphType.CANVAS_VERSION])],
  ['con', new Set([GeneratedDomainGraphType.CONTAINER])],
  ['configimphist', new Set([GeneratedDomainGraphType.CONFIG_IMPORT_HISTORY_ENTRY])],
  ['consch', new Set([GeneratedDomainGraphType.CONTAINER_SCHEMA])],
  ['dataset', new Set([GeneratedDomainGraphType.DATASET])],
  ['doc', new Set([GeneratedDomainGraphType.DOCUMENT])],
  ['docpart', new Set([GeneratedDomainGraphType.DOCUMENT_PART])],
  ['dset', new Set([GeneratedDomainGraphType.DATA_FRAME])],
  [
    'ent',
    new Set([
      GeneratedDomainGraphType.ORGANIZATION,
      GeneratedDomainGraphType.SERVICE_PRINCIPAL,
      GeneratedDomainGraphType.USER,
    ]),
  ],
  ['enz', new Set([GeneratedDomainGraphType.ENZYME])],
  ['enzl', new Set([GeneratedDomainGraphType.ENZYME_LIST])],
  ['etr', new Set([GeneratedDomainGraphType.ENTRY])],
  ['evtsub', new Set([GeneratedDomainGraphType.EVENT_SUBSCRIPTION])],
  ['exmpl', new Set([GeneratedDomainGraphType.EXAMPLE_TYPE])],
  ['feat', new Set([GeneratedDomainGraphType.FEATURE_LIBRARY_ITEM])],
  ['featlib', new Set([GeneratedDomainGraphType.FEATURE_LIBRARY])],
  ['file', new Set([GeneratedDomainGraphType.FILE])],
  ['fmdef', new Set([GeneratedDomainGraphType.FORM_DEFINITION])],
  ['grmln', new Set([GeneratedDomainGraphType.GERMLINE])],
  ['intrfc', new Set([GeneratedDomainGraphType.FIELDSET])],
  ['ipl', new Set([GeneratedDomainGraphType.INTERNAL_PIPELINE])],
  [
    'jfsch',
    new Set([GeneratedDomainGraphType.BENCHLING_OBJECT_SCHEMA_V2, GeneratedDomainGraphType.JELLYFISH_SCHEMA]),
  ],
  ['jly', new Set([GeneratedDomainGraphType.JELLYFISH])],
  ['lad', new Set([GeneratedDomainGraphType.LADDER])],
  ['lbltmp', new Set([GeneratedDomainGraphType.LABEL_TEMPLATE])],
  ['ldirun', new Set([GeneratedDomainGraphType.LEGACY_DATA_IMPORT_RUN])],
  ['lib', new Set([GeneratedDomainGraphType.FOLDER])],
  ['loc', new Set([GeneratedDomainGraphType.LOCATION])],
  ['locsch', new Set([GeneratedDomainGraphType.LOCATION_SCHEMA])],
  ['mcpconf', new Set([GeneratedDomainGraphType.MCP_SERVER_CONFIG])],
  ['mcpdef', new Set([GeneratedDomainGraphType.MCP_SERVER_DEFINITION])],
  ['mcpusr', new Set([GeneratedDomainGraphType.MCP_SERVER_USER_CONFIG])],
  ['mdlrun', new Set([GeneratedDomainGraphType.PREDICTION_BATCH])],
  ['modnuc', new Set([GeneratedDomainGraphType.MODIFIED_NUCLEOTIDE])],
  ['mol', new Set([GeneratedDomainGraphType.MOLECULE])],
  ['mxt', new Set([GeneratedDomainGraphType.MIXTURE])],
  ['pardef', new Set([GeneratedDomainGraphType.LIBRARY_PARAMETER_DEFINITION])],
  ['pc', new Set([GeneratedDomainGraphType.PROCEDURE])],
  ['pcfc', new Set([GeneratedDomainGraphType.PROCEDURE_FLOWCHART])],
  ['pcfcv', new Set([GeneratedDomainGraphType.PROCEDURE_FLOWCHART_VERSION])],
  ['pcmdv', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_DEFINITION_VERSION])],
  ['pcmei', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE])],
  ['pcmeiasn', new Set([GeneratedDomainGraphType.PROCEDURE_METHOD_EXECUTION_INSTANCE_ASSOCIATION])],
  ['pcparam', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER])],
  ['pcr', new Set([GeneratedDomainGraphType.PROCEDURE_RUN])],
  ['pcrc', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_CONDITION])],
  ['pcrre', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_REPLICATE_EDGE])],
  ['pcsdv', new Set([GeneratedDomainGraphType.PROCEDURE_STEP_DEFINITION_VERSION])],
  ['pcsei', new Set([GeneratedDomainGraphType.PROCEDURE_STEP_EXECUTION_INSTANCE])],
  [
    'plt',
    new Set([
      GeneratedDomainGraphType.MATRIX_PLATE,
      GeneratedDomainGraphType.PLATE,
      GeneratedDomainGraphType.WELL_PLATE,
    ]),
  ],
  [
    'pltsch',
    new Set([
      GeneratedDomainGraphType.MATRIX_PLATE_SCHEMA,
      GeneratedDomainGraphType.PLATE_SCHEMA,
      GeneratedDomainGraphType.WELL_PLATE_SCHEMA,
    ]),
  ],
  ['pol', new Set([GeneratedDomainGraphType.POLICY])],
  ['ppvc', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_CONFIRMATION_VALUE])],
  ['ppvm', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_MEASURED_VALUE])],
  ['ppvp', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_PLANNED_VALUE])],
  ['prcr', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_CONDITION_REPLICATE])],
  ['predjb', new Set([GeneratedDomainGraphType.PREDICTION_JOB])],
  ['print', new Set([GeneratedDomainGraphType.PRINTER])],
  ['prp', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_PLAN])],
  ['prpc', new Set([GeneratedDomainGraphType.PROCEDURE_RUN_PLAN_CONDITION])],
  ['prs', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_GROUP])],
  ['prsosch', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT_SCHEMA])],
  ['prstsch', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_SCHEMA])],
  ['prtn', new Set([GeneratedDomainGraphType.AA_SEQUENCE])],
  ['pubrcrd', new Set([GeneratedDomainGraphType.PUBLISHING_RECORD])],
  ['qnty', new Set([GeneratedDomainGraphType.UNIT_TYPE])],
  ['reqtsksch', new Set([GeneratedDomainGraphType.REQUEST_TASK_SCHEMA])],
  ['result', new Set([GeneratedDomainGraphType.RESULT])],
  ['rqdf', new Set([GeneratedDomainGraphType.REQUEST_V2_DEFINITION])],
  ['rqsm', new Set([GeneratedDomainGraphType.REQUEST_V2_SUBMISSION])],
  ['rtn', new Set([GeneratedDomainGraphType.ROUTINE])],
  ['rtnexe', new Set([GeneratedDomainGraphType.ROUTINE_EXECUTION])],
  ['run', new Set([GeneratedDomainGraphType.RUN])],
  ['rxn', new Set([GeneratedDomainGraphType.REACTION])],
  ['sbtmpl', new Set([GeneratedDomainGraphType.ENTRY_SUBTEMPLATE])],
  ['schver', new Set([GeneratedDomainGraphType.PROCEDURE_PARAMETER_VERSION])],
  ['scrfile', new Set([GeneratedDomainGraphType.SCRATCH_FILE])],
  ['scrplt', new Set([GeneratedDomainGraphType.SCRATCH_PLATE])],
  [
    'seq',
    new Set([
      GeneratedDomainGraphType.DNA_OLIGO,
      GeneratedDomainGraphType.DNA_SEQUENCE,
      GeneratedDomainGraphType.RNA_OLIGO,
      GeneratedDomainGraphType.RNA_SEQUENCE,
    ]),
  ],
  ['seqanl', new Set([GeneratedDomainGraphType.NUCLEOTIDE_ALIGNMENT])],
  ['sesn', new Set([GeneratedDomainGraphType.APP_SESSION])],
  ['sfs', new Set([GeneratedDomainGraphType.DROPDOWN])],
  ['sfso', new Set([GeneratedDomainGraphType.DROPDOWN_OPTION])],
  ['slt', new Set([GeneratedDomainGraphType.SALT])],
  ['slvt', new Set([GeneratedDomainGraphType.SOLVENT])],
  ['smpldef', new Set([GeneratedDomainGraphType.SAMPLE_DEFINITION])],
  ['smpltstplan', new Set([GeneratedDomainGraphType.STUDY_SAMPLE_TEST_PLAN])],
  ['smpltyp', new Set([GeneratedDomainGraphType.SAMPLE_TYPE])],
  ['spltdsgn', new Set([GeneratedDomainGraphType.PLATE_DESIGN_TEMPLATE])],
  ['src', new Set([GeneratedDomainGraphType.PROJECT, GeneratedDomainGraphType.REGISTRY])],
  ['ssi', new Set([GeneratedDomainGraphType.STATIC_SCHEMA_INTERFACE])],
  ['star', new Set([GeneratedDomainGraphType.STAR])],
  ['stdy', new Set([GeneratedDomainGraphType.STUDY])],
  ['stdydsgn', new Set([GeneratedDomainGraphType.TRIAL_SAMPLE_TESTING_STUDY_DESIGN])],
  ['stdyitasn', new Set([GeneratedDomainGraphType.STUDY_ITEM_ASSOCIATION])],
  ['stdysch', new Set([GeneratedDomainGraphType.STUDY_SCHEMA])],
  ['stgentr', new Set([GeneratedDomainGraphType.STAGE_ENTRY])],
  ['svdrltmpl', new Set([GeneratedDomainGraphType.STATIC_VALIDATION_RULE_TEMPLATE])],
  ['tcfg', new Set([GeneratedDomainGraphType.TENANT_CONFIG])],
  ['tdef', new Set([GeneratedDomainGraphType.TEST_DEFINITION])],
  ['team', new Set([GeneratedDomainGraphType.TEAM])],
  ['tgsch', new Set([GeneratedDomainGraphType.BENCHLING_OBJECT_SCHEMA_V2])],
  ['tmpl', new Set([GeneratedDomainGraphType.ENTRY_TEMPLATE])],
  ['tmplcol', new Set([GeneratedDomainGraphType.TEMPLATE_COLLECTION])],
  ['tntcl', new Set([GeneratedDomainGraphType.TENTACLE])],
  ['tord', new Set([GeneratedDomainGraphType.TEST_ORDER])],
  ['trtmntgrp', new Set([GeneratedDomainGraphType.TREATMENT_GROUP])],
  [
    'ts',
    new Set([
      GeneratedDomainGraphType.AA_SEQUENCE_SCHEMA,
      GeneratedDomainGraphType.CUSTOM_ENTITY_SCHEMA,
      GeneratedDomainGraphType.DNA_OLIGO_SCHEMA,
      GeneratedDomainGraphType.DNA_SEQUENCE_SCHEMA,
      GeneratedDomainGraphType.ENTITY_SCHEMA,
      GeneratedDomainGraphType.ENTRY_SCHEMA,
      GeneratedDomainGraphType.EQUIPMENT_SCHEMA,
      GeneratedDomainGraphType.MIXTURE_SCHEMA,
      GeneratedDomainGraphType.MOLECULE_SCHEMA,
      GeneratedDomainGraphType.OLIGO_CONJUGATE_SCHEMA,
      GeneratedDomainGraphType.OLIGO_DUPLEX_SCHEMA,
      GeneratedDomainGraphType.PROTEIN_SCHEMA,
      GeneratedDomainGraphType.RNA_OLIGO_SCHEMA,
      GeneratedDomainGraphType.RNA_SEQUENCE_SCHEMA,
    ]),
  ],
  [
    'tsf',
    new Set([
      GeneratedDomainGraphType.AA_PART_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.AA_SEQUENCE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ANTIBODY_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ANY_ENTITY_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ASSAY_REQUEST_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ASSAY_RESULT_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ASSAY_RUN_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.BASE_FIELD_DEFINITION,
      GeneratedDomainGraphType.BASE_MOLECULE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.BLOB_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.BOOLEAN_FIELD_DEFINITION,
      GeneratedDomainGraphType.CUSTOM_ENTITY_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.DATE_FIELD_DEFINITION,
      GeneratedDomainGraphType.DATE_TIME_FIELD_DEFINITION,
      GeneratedDomainGraphType.DNA_OLIGO_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.DNA_PART_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.DNA_SEQUENCE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.DROPDOWN_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.ENTRY_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.EQUIPMENT_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.FIELDSET_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.FLOAT_FIELD_DEFINITION,
      GeneratedDomainGraphType.INTEGER_FIELD_DEFINITION,
      GeneratedDomainGraphType.JSON_FIELD_DEFINITION,
      GeneratedDomainGraphType.LONG_TEXT_FIELD_DEFINITION,
      GeneratedDomainGraphType.MIXTURE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.MOLECULE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.OLIGO_CONJUGATE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.OLIGO_DUPLEX_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.RNA_OLIGO_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.RNA_SEQUENCE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.SCHEMA_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.STORABLE_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.SYSTEM_CATEGORY_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.TEXT_FIELD_DEFINITION,
      GeneratedDomainGraphType.TRANSCRIPTION_LINK_FIELD_DEFINITION,
      GeneratedDomainGraphType.TRANSLATION_LINK_FIELD_DEFINITION,
    ]),
  ],
  ['unit', new Set([GeneratedDomainGraphType.UNIT])],
  ['vdrl', new Set([GeneratedDomainGraphType.VALIDATION_RULE])],
  ['wffcc', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_CONFIG])],
  [
    'wffccv',
    new Set([
      GeneratedDomainGraphType.PROCEDURE_FLOWCHART_CONFIG_VERSION_PROXY,
      GeneratedDomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION,
    ]),
  ],
  ['wffcec', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_EDGE_CONFIG])],
  ['wffnc', new Set([GeneratedDomainGraphType.WORKFLOW_FLOWCHART_NODE_CONFIG])],
  ['wfond', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT_NODE_DETAILS])],
  ['wfout', new Set([GeneratedDomainGraphType.WORKFLOW_OUTPUT])],
  ['wfrf', new Set([GeneratedDomainGraphType.WORKFLOW_ROUTER_FUNCTION])],
  ['wfrnd', new Set([GeneratedDomainGraphType.WORKFLOW_ROUTER_NODE_DETAILS])],
  ['wfrtnd', new Set([GeneratedDomainGraphType.WORKFLOW_ROOT_NODE_DETAILS])],
  ['wftask', new Set([GeneratedDomainGraphType.WORKFLOW_TASK])],
  ['wftdef', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_DEFINITION])],
  ['wftdefv', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_DEFINITION_VERSION])],
  ['wftnd', new Set([GeneratedDomainGraphType.WORKFLOW_TASK_NODE_DETAILS])],
  ['wftrnd', new Set([GeneratedDomainGraphType.WORKFLOW_END_NODE_DETAILS])],
  ['whlogin', new Set([GeneratedDomainGraphType.WAREHOUSE_CREDENTIAL])],
  ['whview', new Set([GeneratedDomainGraphType.WAREHOUSE_CUSTOM_VIEW])],
  ['wkl', new Set([GeneratedDomainGraphType.WORKLIST])],
  ['wks', new Set([GeneratedDomainGraphType.WORKSHEET])],
] as const;

/** @package */
export const ID_PREFIX_TO_DOMAIN_GRAPH_TYPES: Record<CoreObjectIdPrefix, Set<ObjectType>> = objectFromEntries(
  ID_PREFIX_TO_DOMAIN_GRAPH_TYPES_ENTRIES as unknown as Array<[CoreObjectIdPrefix, Set<ObjectType>]>
);
